import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-lg shadow p-8">
          <h1 className="text-4xl font-bold mb-2">Privacy Policy</h1>
          <p className="text-gray-500 mb-8">Last updated: February 2026</p>

          <div className="prose max-w-none text-gray-600 space-y-6">

            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-3">1. Introduction</h2>
              <p>
                ContractGuard ("we", "us", "our") is committed to protecting your privacy. This Privacy
                Policy explains how we collect, use, and safeguard your personal information when you use
                our website and services at contractguard.com.au.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-3">2. Information We Collect</h2>
              <p className="mb-2">We collect the following types of information:</p>
              <ul className="list-disc list-inside space-y-1 ml-4">
                <li><strong>Account information:</strong> Email address and password when you register</li>
                <li><strong>Payment information:</strong> Processed securely through Stripe — we do not store card details</li>
                <li><strong>Contract documents:</strong> Files you upload for analysis</li>
                <li><strong>Usage data:</strong> How you interact with our platform</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-3">3. How We Use Your Information</h2>
              <ul className="list-disc list-inside space-y-1 ml-4">
                <li>To provide and improve our contract analysis services</li>
                <li>To process payments and manage your subscription</li>
                <li>To send service-related emails (e.g. account verification, receipts)</li>
                <li>To respond to your enquiries and provide support</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-3">4. Document Storage</h2>
              <p>
                Uploaded contracts are processed by our AI system and stored securely. Documents are
                associated with your account and accessible in your dashboard. You may delete your
                documents at any time. We do not share your documents with third parties.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-3">5. Third-Party Services</h2>
              <p className="mb-2">We use the following third-party services:</p>
              <ul className="list-disc list-inside space-y-1 ml-4">
                <li><strong>Stripe:</strong> Payment processing</li>
                <li><strong>Supabase:</strong> Database and authentication</li>
                <li><strong>Anthropic (Claude AI):</strong> Contract analysis</li>
              </ul>
              <p className="mt-2">Each service has its own privacy policy governing their use of data.</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-3">6. Data Security</h2>
              <p>
                We implement industry-standard security measures including encryption in transit (HTTPS),
                secure authentication, and access controls to protect your data.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-3">7. Your Rights</h2>
              <p className="mb-2">Under Australian Privacy Law, you have the right to:</p>
              <ul className="list-disc list-inside space-y-1 ml-4">
                <li>Access the personal information we hold about you</li>
                <li>Request correction of inaccurate information</li>
                <li>Request deletion of your account and data</li>
              </ul>
              <p className="mt-2">To exercise these rights, contact us at admin@contractguard.com.au</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-3">8. Contact</h2>
              <p>
                For privacy-related enquiries, contact us at:{' '}
                <a href="mailto:admin@contractguard.com.au" className="text-primary-600 hover:text-primary-700">
                  admin@contractguard.com.au
                </a>
              </p>
            </section>

          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
